import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';
import { StatiIncaricoComponent } from 'src/app/admin/stati-incarico/stati-incarico.component';
import { StatoIncarico } from 'src/app/models/stato-incarico';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { Model } from '../../../../models/model';
import { takeUntil } from 'rxjs/operators';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => StatoIncaricoPickerComponent) },
  ],
  selector: 'stato-incarico-picker',
  //templateUrl: '../../external-selector/external-selector.component.html',
  templateUrl: './stato-incarico-picker.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class StatoIncaricoPickerComponent extends ExternalSelectorComponent {

  @Input() fromSearch = false;
  @Input()
  get externalEntityObserver(): Observable<any> {
    //console.log(this.fromSearch);
    let picked = this.dialog.open(StatiIncaricoComponent, { data: { selectionMode: !this.fromSearch, multipleSelection: this.fromSearch, showReset: true } }).afterClosed();
    picked.subscribe(val => {
      let stato = new StatoIncarico().deserialize(val);
      console.log(stato);
      return stato;
    });
    return picked;
  };

  parts: FormGroup = this.fb.group({
    humanIdentifier: [''],
    id: [''],
  });

  query: FormGroup = this.fb.group({
    states: new FormArray([])
  });

  registerOnChange(onChange: (value: Model | null) => void): void {
    if (this.fromSearch) {
    this.query.valueChanges.pipe(
      takeUntil(this.destroy),
    ).subscribe((value) => { if (value.states) onChange(value.states)});
    } else super.registerOnChange(onChange)
  }

  public writeValue(value?: any): any {

    if (value === null) {
      this.parts.reset();
      const statesArray = this.query.get('states') as FormArray
      statesArray.clear();

      this.stateChanges.next();

    }
    else if (this.fromSearch) {
      let newValue = { state: [], humanIdentifier: '' };
      //const states = new FormArray(value.map(item => (new FormGroup({ id: new FormControl(item.id), humanIdentifier: new FormControl(item.humanIdentifier) }))))
      const states = new FormArray(value.map(item => (new FormControl(item.id))))

      this.parts.patchValue({ humanIdentifier: value.map(item => item.humanIdentifier).join(', ') });
      this.query.setControl('states', states)
      this.stateChanges.next();
    } else {
      super.writeValue(value)
    }


  }


}
